import moment from 'moment';

const dateUtil = {

    formatDate: (date) => {
        return moment(date).format("DD.MM.YYYY")
    },

    formatDateTime: (date) => {
        return moment(date).format("DD.MM.YYYY H:M:S")
    },

    dateToday: () => {
        const today = new Date();
        const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const dateTime = date;
        return dateTime;
    },

    dateTimeToday: () => {
        const today = new Date();
        const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const dateTime = date +' '+ time;
        return dateTime;
    },

    age: (date) => {
        var age_dt, diff_ms, the_age, the_date;
        the_date = new Date(date);
        diff_ms = Date.now() - the_date.getTime();
        age_dt = new Date(diff_ms);
        the_age = Math.abs(age_dt.getUTCFullYear() - 1970);
        return the_age;
    },

    date_diff_now: (d) => {

        if (d) {
            var c_date = moment(String(d)).format('YYYY-MM-DD')
            var now = Date()
            var now = moment(String(now)).format('YYYY-MM-DD')
            var diff = now - c_date
            return diff
        }
    },

}

export default dateUtil;

